import { render, staticRenderFns } from "./FilterList.vue?vue&type=template&id=0d97a5b1&scoped=true"
import script from "./FilterList.vue?vue&type=script&lang=js"
export * from "./FilterList.vue?vue&type=script&lang=js"
import style0 from "./FilterList.vue?vue&type=style&index=0&id=0d97a5b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d97a5b1",
  null
  
)

export default component.exports